import { render, staticRenderFns } from "./BaseDynamicLoader.vue?vue&type=template&id=3b1d4ec6&scoped=true"
import script from "./BaseDynamicLoader.vue?vue&type=script&lang=js"
export * from "./BaseDynamicLoader.vue?vue&type=script&lang=js"
import style0 from "./BaseDynamicLoader.vue?vue&type=style&index=0&id=3b1d4ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d4ec6",
  null
  
)

export default component.exports